export default (custom_buildings, policy_id = null) => {
  return custom_buildings.map((custom_building) => {
    return {
      ...custom_building,
      policy_id: policy_id
    }
  })
}